export default {
  firstName: "Marko",
  lastName: "K.",
  overview: `Hello, My name is <span>Marko</span>.<br> 
        I am a software developer who started programming in grade school. 
        After getting a <span>bachelor's degree</span> in Computer Software Engineering, 
        I worked for two large international companies-developing mostly <span>web applications</span> for several years. 
        I am accustomed to a distributed environment and working with <span>remote clients</span> using <span>agile methodologies</span>.`,
  contactInfo: {
    location: "Belgrade, Serbia",
    phoneNumber: "(+1) ‪484 630-0933‬",
    email: "loob2dev@gmail.com",
  },
  social: {
    github: "https://github.com/loob2dev",
    linkedin: "https://www.linkedin.com/in/marko-petrovic-193190200/",
    // instagram: "",
  },
  jobs: [
    {
      company: "Self=employed",
      position: "Software DEVELOPER",
      duration: "NOV 2020 – PRESENT",
      detail: `
            •&nbsp&nbsp&nbsp Implemented UI components on ecommerce platform with ReactJS and VueJS
            <br/>
            •&nbsp&nbsp&nbsp Implemented RestFul API using FastAPI and PostgresSQL
            <br/>
            •&nbsp&nbsp&nbsp Built the client app in React Native
            <br/>
            •&nbsp&nbsp&nbsp Enabled the app to work across all the major mobile operation systems including Android, IOS
        `,
    },
    {
      company: "Win Computers",
      position: "Full Stack DEVELOPER",
      duration: "MAR 2016 – OCT 2020",
      detail: `   
            •&nbsp&nbsp&nbsp Built from scratch admin platform for managing platform’s database entities and users using React, Node.js, and Mongoose.
            <br/>
            •&nbsp&nbsp&nbsp Implemented complex UI components with ReactJS, and Vuejs.
            <br/>
            •&nbsp&nbsp&nbsp Improved the UX by creating serveral DnD-based components.
            <br/>
            •&nbsp&nbsp&nbsp Worked on providing API endpoints with Spring Boot.
            <br/>
            •&nbsp&nbsp&nbsp Developed a prototype used to visualize transportation routes using React, Antd, and Deck.gl
            <br/>
            •&nbsp&nbsp&nbsp Built a scheduling tool in the form of a Gantt chart using React and Material-UI
            <br/>
            •&nbsp&nbsp&nbsp Researched and selected Libraries and tools
            <br/>
            •&nbsp&nbsp&nbsp Balanced requirements, UX, and deadlines in order to get most of the business value in a limited timeframe
            <br/>
            •&nbsp&nbsp&nbsp Composed scripts-with Python and Node.js-to parse complex data structures
          `,
    },
    {
      company: "Gigatron Computeres",
      position: "FRONT-END DEVELOPER",
      duration: "JAN 2012 – Feb 2016",
      detail: `
            •&nbsp&nbsp&nbsp Finished implementing a cryptocurrency exchange built using Angular
            <br/>
            •&nbsp&nbsp&nbsp Handled the pixel-perfect implementation of the specs(Zeplin)
            <br/>
            •&nbsp&nbsp&nbsp Used Angular animations to improve the overall UX
            <br/>
            •&nbsp&nbsp&nbsp Converted a web app to a native version using React Native
            <br/>
            •&nbsp&nbsp&nbsp Transformed the app to be mobile-first and fully responsive
            •&nbsp&nbsp&nbsp Worked on several mobile-first web application with rich user experiences
            <br/>
            •&nbsp&nbsp&nbsp Led the development process of a portfolio management tool application for an investment company
            `,
    },
    {
      company: "SoftwareOne",
      position: "Software DEVELOPER",
      duration: "Oct 2007 – Dec 2011",
      detail: `
            •&nbsp&nbsp&nbsp Designed several charts for the visualization of complex data using D3.js
            <br/>
            •&nbsp&nbsp&nbsp Mentored and knowledge-shared with younger colledgues
            <br/>
            •&nbsp&nbsp&nbsp build frontend flexibility using HTML, CSS, and JavaScript.
            `,
    },
  ],
  skills: [
    { name: "ReactJS", level: 100 },
    { name: "Angular", level: 60 },
    { name: "VueJS", level: 100 },
    { name: "D3", level: 70 },
    { name: "ExpressJS", level: 90 },
    { name: "Django", level: 80 },
    { name: "Flask", level: 90 },
    { name: "FastAPI", level: 98 },
    { name: "PostgresSQL", level: 90 },
    { name: "MongoDB", level: 90 },
    { name: "Android", level: 80 },
    { name: "IOS", level: 60 },
    { name: "React Native", level: 90 },
  ],
  services: [
    {
      name: "Stunning Interfaces",
      icon: "./img/icon/interfaces.png",
      detail: `UX design and UI Development using ReactJS with Redux, Angular, 
        Vue with Vuex to deliver pixel perfect screen according to your 
        high/low fedility mock-ups. Migrate your UI with me. I am agile, my UI/UX is cool.`,
    },
    {
      name: "Application Development",
      icon: "./img/icon/application.png",
      detail: `Right technology, Right framework and right mix save you bigger costs on 
        Application Development. Strong Java, NodeJS engineer at work. Try, 
        compare and refer. I work 30% faster than market demand!`,
    },
    {
      name: "Data Engineering Infrastructure",
      icon: "./img/icon/data.png",
      detail: `Data Modeling and Warehousing using Hadoop, Map Reduce, Data Transfer 
        (Sqoop), Pig and Hive. Expertise in Spark data pipelines from S3 to DBs. 
        Reduce cost by 40% with me. Redeisgn your infrastructure.`,
    },
    {
      name: "Analytics on Cloud",
      icon: "./img/icon/analytics.png",
      detail: `​Advanced self-service analytics consultation and cloud application development. 
          Expert consultation and ingetration of Gartner's MQ leaders Tableau, Qlik Sense, 
          Power BI, Saleforce Einstein Analytics & AWS Quick Sight`,
    },
  ],
  works: [
    {
      category: "web react gatsby",
      name: "Agence Belle Epoque",
      imgSrc: "./my-works/website/Agence Belle Epoque/Agence Belle Epoque.png",
      detail: "Agence Belle Epoque is a intruduction site of a company.",
      role:
        "I built it from scratch as a frontend developer for Agence Belle. It works on ReactJS framework",
      technologies: "React",
      url: "https://agence-belle-epoque.fr/",
    },
    {
      category: "mobile native",
      name: "BackCountry navigator",
      imgSrc: "./my-works/Mobile/BackCountry Navigator/BackCountry.png",
      detail:
        "Use GPS waypoints from GPX or KML files, or enter your own coordinates using longitude/latitude, UTM, MGRS, or grid reference. Using GOTO makes a waypoint a locus for navigation.",
      role: "I fixed the bug in finding the elevation, and update UI",
      technologies: "Objective C",
      url:
        "https://apps.apple.com/us/app/gaia-gps-hiking-hunting-maps/id1201979492",
    },
    {
      category: "hybrid",
      name: "DeliverX",
      videoSrc: "./my-works/Mobile/Deliver/Deliver.mp4",
      imgSrc: "./my-works/Mobile/Deliver/deliver.png",
      detail:
        "This is a mockup. I soved the problem to use Turn by Turn Map Navigation",
      role:
        "I built this open-source to solve the problem that implementing turn by turn map navigation in React Native platform. For it, I combined Native and Javascript code in this project.",
      technologies: "React Native",
      url: "",
    },

    {
      category: "react",
      name: "ChinaLove",
      imgSrc: "./my-works/website/ChinaLove/ChinaLove.png",
      detail: "ChianLove is a Dating platform in China.",
      role:
        "I worked as a full stack developer. the goal of this project is to implement a call function. So I use WebRTC and firebase on this site. the frontend is based on React.js and the backend is based on Node.js",
      technologies: "React.js",
      url: "https://www.chinalove.com/",
    },
    {
      category: "native",
      name: "Meetville",
      imgSrc: "./my-works/Mobile/Meetville/Meetville.png",
      detail: "Chat online & meet new people in one of the best dating apps.",
      role:
        "My role was as an android developer. I integrated Twillio for a call feature, and Google Map to pin the best matches in this app.",
      technologies: "Java",
      url: "https://play.google.com/store/apps/details?id=com.meetville.dating",
    },
    {
      category: "vue",
      name: "ChinesePod",
      imgSrc: "./my-works/Mobile/chinesePod/chinesepod.png",
      detail:
        "Innovating online Mandarin learning for over 15 years. · Sign Up Today! · Real Language · Self Contained Lessons · Exercises · Vocabulary · Pronunciation.",
      role:
        "I worked as a full-stack developer. I update the frontend according to a new design using Vue.js and implemented a payment feature in the backend using stripe.",
      technologies: "vue.js | node.js",
      url: "https://www.chinesepod.com/",
    },
    {
      category: "hybrid",
      name: "Painting",
      videoSrc: "./my-works/Mobile/painting/painting.mp4",
      imgSrc: "./my-works/Mobile/painting/paint.png",
      detail: "This app works with svg",
      role:
        "It is a React Native open-source. The goal is to change the fixed image with any SVG file. Users can fill color in a closed area in the SVG image.",
      technologies: "React Native",
      url: "",
    },
    {
      category: "native",
      name: "Roadvision",
      imgSrc: "./my-works/Mobile/roadvision/roadvision.jpg",
      detail:
        "Roadvision works as a car black box, dash cam or car DVR cam, keeping to capture videos and photos during your driving. The app automatically records everything, but only important events are retained for future reference or as evidence. You get to choose what to keep, simply by touching the screen, even while you drive.",
      role:
        "I fixed the black screen on Samsung android Phone. It was a Wifi protocal error between a Dash Camera and a Samsung phone.",
      technologies: "Java",
      url:
        "https://play.google.com/store/apps/details?id=au.com.CarDVR.Roadvision&hl=en_IN&gl=US",
    },
    {
      category: "react node",
      name: "Fast online trading",
      imgSrc: "./my-works/website/Fast/Fast online trading.png",
      detail:
        "Clients are granted limited non-exclusive rights to use the IP contained in this site for personal, non-commercial, non-transferable use only in relation to the services offered on the site.",
      role:
        "I implemented blockchain technology in this project as a full-stack developer",
      technologies: "ReactJS | ExperssJS",
      url: "https://expertoption.com/",
    },
    {
      category: "react node",
      name: "Flixxo",
      imgSrc: "./my-works/website/Flixxo/Flixxo.png",
      detail:
        "Flixxo takes the most out of peer to peer video distribution and cryptocurrencies for building up a video revolution.",
      role:
        "My role was as a Full stack developer. I fixed lose connection error in peer to peer video distribution",
      technologies: "TweenMax, ReactJS, ExperssJS",
      url: "https://www.flixxo.com/",
    },
    {
      category: "vue cms",
      name: "Gift Ideas",
      imgSrc: "./my-works/website/Gift Ideas/Gift Ideas.png",
      detail:
        "The client will receive friendly and expert advice to help you choose the right products and guide you through the process of ordering, whether it is a single order or a larger project.",
      role:
        "I worked as a Front-end developer from scratch. I designed reusability in the project",
      technologies: "Vue.js Shopify",
      url: "https://hauslondon.com/",
    },
    {
      category: "cms",
      name: "Negharhonooni",
      imgSrc: "./my-works/website/Negharhonooni/Negharhonooni.png",
      detail:
        "Negharhonooni is a site for weirdos, witches, misfits, magic makers, and moon lovers.",
      role: "I plugged in WooCommerce and Elementor in this WordPress website.",
      technologies: "Wordperss",
      url: "http://www.negharfonooni.com/",
    },
    {
      category: "angular node",
      name: "Smart Coverage",
      imgSrc: "./my-works/website/Smart Coverage/Smart Coverage.png",
      detail:
        "Hippo Insurance launched in 2015 with the deep belief that homeowners deserve better home insurance.",
      role: "It is a company website. I worked as a Full-Stack developer",
      technologies: "Angular | NodeJs",
      url: "https://myhippo.com/",
    },
    {
      category: "node",
      name: "Tradealike",
      imgSrc: "./my-works/website/Tradealike/Tradealike.png",
      detail:
        "Tradealike is a mobile platform for Financial market traders to provide actionable trade alerts to individuals who seek a simple and transparent alerting format.",
      role: "It is a trading site with cryptocurrency",
      technologies: "ExpressJs",
      url: "https://www.tradealike.com/",
    },
    {
      category: "react",
      name: "Varbyparker",
      imgSrc: "./my-works/website/Varbyparker/Varbyparker.png",
      detail: "VarbyParker is an Argument Reality Shopping site.",
      role:
        "It is an eCommerce site. I designed and built it from scratch as a React developer",
      technologies: "BacknoneJs | React",
      url: "https://www.warbyparker.com/",
    },
    {
      category: "angular",
      name: "Verbling",
      imgSrc: "./my-works/website/Verbling/Verbling.png",
      detail:
        "Verbling is a site for language lessons with native 5-star teachers over video chat.",
      role:
        "I implemented FCM and Realtime Database. My role was as a React and DevOps developer",
      technologies: "React | firebase",
      url: "https://www.verbling.com/",
    },
    {
      category: "navite",
      name: "Abra",
      imgSrc: "./my-works/Mobile/Abra/abra.png",
      detail:
        "Abra is the world’s first global investment app that enables you to invest in hundreds of cryptocurrencies* like Bitcoin, Ethereum, XRP, Litecoin, Stellar, Monero and many more all in one app.",
      role:
        "I built the cryptocurrency wallet Mobile application integrated Restful APIs Php backend as a IOS developer.",
      technologies: "Objective C",
      url: "https://apps.apple.com/us/app/abra-bitcoin-xrp-ltc/id966301394",
    },

    {
      category: "native",
      name: "Go SMS Pro",
      imgSrc: "./my-works/Mobile/Go SMS Pro/Go SMS Pro.png",
      detail:
        "GO SMS Pro comes with beautiful themes, lovely stickers, private box, pop up windows, GO chat (send free SMS & MMS), dual sim support, and much more.",
      role: "I integrated Twillio APIs in the React Native mobile application",
      technologies: "React Native",
      url: "https://play.google.com/store/apps/details?id=com.jb.gosms&hl=en",
    },
    {
      category: "hybrid",
      name: "LookMovie",
      imgSrc: "./my-works/Mobile/lookmovie/lookmovie.jpg",
      detail:
        "Stream hls video, Activity detail screen, Profile screen, Profile update screen, Likes & Comments, Status update with hashtags, mentions, URL enrichment and image upload",
      role:
        "I designed the mobile application by referencing the website and built it. the website is based on Vue. The challenge was to show too many videos in the Listview of the React Native. I complete it successfully and it streamed HLS videos flexibly based on the Node.js backend. I published it as an open-source on my Git repository.",
      technologies: "React Native",
      url: "https://lookmovie.ag/",
      videoSrc: "./my-works/Mobile/lookmovie/look movie.mp4",
    },

    {
      category: "native",
      name: "Nykka Beauty Shopping",
      imgSrc: "./my-works/Mobile/Nykka/Nykka Beauty Shopping.png",
      detail:
        "Nykaa is a premier online beauty app that allows you to choose from over 1 Lakh beauty products and 850+ brands.",
      role:
        "It is my first IOS mobile application. I partispated in this project as a mobile developer with a small team. We keeped a good communcation and demonstrated team cooperationship so that deliver a good result",
      technologies: "Swift",
      url:
        "https://apps.apple.com/us/app/nykaa-makeup-beauty-shopping/id1022363908",
    },
    {
      category: "react",
      name: "partnership",
      imgSrc: "./my-works/website/partnership/partnership.png",
      detail:
        "Trinity Charities Partners With An Amazing List Of Global Organizations. Partner With Us To Minister To The Physical, Social And Spiritual Needs Of Our Community. Community Building. Volunteering. Food Pantry.",
      role:
        "I worked as a React developer. The design and requirements are so simple that I can build it faster than in others. Furthermore, I have a powerful solution and many templates for building a React web application.",
      technologies: "react ngnix",
      url: "https://partnership.sjp.co.uk/",
    },
    {
      category: "angular",
      name: "massport",
      imgSrc: "./my-works/website/massport/massport.png",
      detail:
        "Boston Logan, Flynn Cruiseport Boston, Conley Terminal, Worcester Regional Airport and Hanscom Field.",
      role:
        "I worked with a .Net developer as an Angular developer. He provides a good relationship, so I can build it easily despite that I have not many experiences with Angular. After completing it, I could have a good knowledge and experience of Angular.",
      technologies: "angular.js asp.net",
      url: "http://massport.com/",
    },
    {
      category: "cms",
      name: "Alumore",
      imgSrc: "./my-works/website/Alumore/alumore.png",
      detail: "csthouse technology and solution platform",
      role:
        "My goal is to update the UI of the WordPress website using Javascript and CSS.",
      technologies: "Wordpress",
      url: "https://alumore.us/",
    },
    {
      category: "vue",
      name: "Coop inc",
      imgSrc: "./my-works/website/ecoop-ph/ecoop-ph.png",
      detail: "coop inc Landing page",
      role:
        "My role was as a Vue developer. Actually, It was my first Vue project. But I demonstrated my skills wonderfully on all sides because I have solid experience with Angular and React. In this project, I was experienced with Vue.",
      technologies: "vue.js php",
      url: "https://www.ecoop.ph/",
    },
    {
      category: "vue",
      name: "Baddog",
      imgSrc: "./my-works/website/baddogcustom/baddogcustom.png",
      detail: "Motorcycle Parts and accessories Shoping sites",
      role:
        " I worked on the project as a Full-Stack developer. It was based on Vue and Laravel framework. I participated in this development from scratch with CTO and designer. We kept in good communication and made a nice result.",
      technologies: "vue.js php",
      url: "https://www.baddogcustom.co.uk/",
    },
    {
      category: "spring",
      name: "Baddog",
      imgSrc: "./my-works/website/wallapop/wallapop.png",
      detail:
        " the biggest sell and buy app in the country, where millions of users buy and sell their new and second hand items and cars",
      role:
        "My role was as a Backend developer. We chose the Spring framework because It is a financial platform. I used QuickBooks tool on the website.",
      technologies: "spring boot",
      url: "https://uk.wallapop.com/",
    },
    {
      category: "spring",
      name: "haflingerzentrum",
      imgSrc: "./my-works/website/haflingerzentru/haflingerzentrum.png",
      detail: " traveling platform",
      role:
        "I worked as a Spring Boot developer on this project. The goal was to implement Bank payment using QuickBooks.",
      technologies: "spring boot",
      url: "https://haflingerzentrum.ch/",
    },
  ],
  clients: [
    {
      name: "Alexander Harvard",
      avatar: "img/testimonial/01.jpg",
      position: "Smashing Magazine",
      testimonial: "Really solid person and great teammate!",
    },
    {
      name: "Shoko Mugikura",
      avatar: "img/testimonial/02.jpg",
      position: "Graphic Designer",
      testimonial:
        "Great skills, quick turnaround and awesome skill skills. 100% recommended!",
    },
    {
      name: "Poul McCartney",
      avatar: "img/testimonial/03.jpg",
      position: "Co Founder / CEO",
      testimonial: "He does awesome work with my family will!",
    },
    {
      name: "Alexander Harvard",
      avatar: "img/testimonial/04.jpg",
      position: "Smashing Magazine",
      testimonial:
        "Very creative person - Mick has added lots of magic to our startup!",
    },
  ],
  blogs: [
    {
      avatar: "./avatar/my_avatar.png",
      image: "./blog/spring_boot.jpg",
      date: "5 February 2021",
      topic: "Spring",
      comment: 0,
      name: "Marko K.",
      title: "Using MapStruct with Project Lombok",
      introduction:
        "MapStruct and Project Lombok are two tools which can make your life as a developer much easier. MapStruct is a slick project which generates type mappers via simple interfaces.  You define an interface method to accept a source type with a return type.  And MapStruct generates the implementation of the mapper. Project Lombok is a tool which helps eliminate a lot of ceremonial / boilerplate code from your Java code.  For example, you can define a POJO with several properties, then use Lombok Annotations to enhance the class with Getters, Setters, Constructors, and Builders.  Project Lombok is a time saver and helps to de-clutter your code. MapStruct will use getters and setters for its mappers.  MapStruct will even utilize Lombok generated builders.  This is a recent addition to MapStruct, and a real nice touch. Both of these projects utilize annotation processing at compile time to work their magic.  This gives them a hook into the Java compile process to enhance the source code being compiled. While great for performance, it does cause us a delicate dance at compile time. If MapStruct is going to use a Lombok generated Builder or Lombok generated Setter, what if Lombok has not run yet? Obviously, the compile would fail. A workaround to this used to be placing all your Lombok enhanced POJOs into a separate module.  This will force Lombok to process before MapStruct, solving our compile time problem. But, this is a kludgey.  With more recent versions of MapStruct and Project Lombok this work around is no longer needed. In this post, I will show you how to configure Maven to support the annotation processing needs to using MapStruct with Project Lombok. ",
      contents: [
        {
          subtitle: "Project Overview",
          content: `
          For the context of this project, let’s say we are developing a Spring Boot Microservice to make ACH Payments.

          There is nothing new about ACH Payments. This standard has been around for over 40 years.
          
          However, a number of banks are now exposing REST style APIs to make ACH Payments. One implementation is by Silicone Valley Bank. You can read their ACH <a target="_blank" href="https://www.svb.com/developers/ach">API documentation here</a>.
          
          So, our hypothetical Spring Boot Microservice will be receiving an instruction to make a ACH Payment. We wish to accept the instruction, persist it to the database, call the ACH API, update the database with the result.`,
        },
        {
          subtitle: "MapStruct and Project Lombok Spring Boot Project",
          content: `
            In this section of the post, we will implement the data models discussed in the previous section, which entails setting up Maven dependencies, configuring Maven’s annotation processing, creating POJOs with Project Lombok annotations, and implementing MapStruct mappers.`,
        },
      ],
    },
    {
      avatar: "./avatar/my_avatar.png",
      image: "./blog/Year in ReVue.jpg",
      date: "23 December 2020",
      topic: "Vue",
      comment: 0,
      name: "Marko K.",
      title: "Where will Vue go in 2021?",
      introduction:
        "It’s safe to say 2020 was quite the year. As it comes to a close, we’re reflecting on the progress that’s been made in the world of Vue and what we’re excited about for 2021.",
      contents: [
        {
          subtitle: "The release we were waiting for",
          content: `
              Our favorite framework has made leaps and bounds from where it was just a year ago, notably due to the major release we’d been waiting for: Vue 3. This brought us a version of Vue rewritten from the ground up to be more powerful, performant, and flexible for developers of every experience level.
              At a high level, Vue 3 brought us:
              <br>
              <br>
              •  A compact size: 20kb gzipped at runtime (or smaller with tree-shaking)
              <br>
              •  The <a target="_blank" href='https://www.vuemastery.com/courses/vue-3-essentials/why-the-composition-api/'>Composition API</a>
              <br>
              •  Enhanced <a target="_blank" href='https://www.vuemastery.com/courses/vue3-typescript/why-vue-&-typescript'>TypeScript</a> support
              <br>
              •  Multi-root Components
              <br>
              •  The <a target="_blank href='https://www.vuemastery.com/courses/vue-3-essentials/teleport/'>teleport</a> component`,
        },
        {
          subtitle: "Vite: Faster hot reloading",
          content: `
              Alongside Vue 3, Vue Creator <a target="_blank" href="https://www.vuemastery.com/courses/vue3-deep-dive-with-evan-you/vue3-overview">Evan You</a> also released a new web dev build tool in 2020: Vite. This tool serves your code via native ES Module imports during development and bundles it with Rollup for production.
  
              The advantages to this approach are:
              <br>
              <br>
              •  The server cold start is super fast because there’s no bundling necessary
              <br>
              •  The only code that is compiled is what’s actually imported on the current view
              <br>
              •  Hot module replacement is consistently fast regardless of app size
              `,
        },
        {
          subtitle: "Nuxt Content Module",
          content: `
              Nuxt.js can be key for <a target="_blank" href="https://www.vuemastery.com/courses/scaling-vue-with-nuxt-js/why-use-nuxt">scaling up your Vue apps</a>. While the Nuxt team is consistently at work improving this fronted framework that sits on top of Vue, a notable addition to the framework for 2020 was the @nuxt/content module. This feature allows you to fetch your Markdown, JSON, YAML, XML and CSV files through a MongoDB-like API, acting as a Git-based Headless CMS.
              `,
        },
        {
          subtitle: "Ionic Vue",
          content: `
              A new player in the Vue community is Ionic’s latest release: <a target="_blank" href="https://www.vuemastery.com/blog/what-you-can-do-with-ionic-vue">Ionic Vue</a>. You might already be familiar with Ionic, a popular framework for developing mobile/hybrid apps using only web technologies (JavaScript, CSS, HTML). With Ionic Vue, we can now use the Vue we know and love, in combination with Ionic’s collection of UI components, to build native apps.
  
              Since Ionic Vue is brand new and already compatible with Vue 3, we can look forward to the potential it can bring for 2021.
              `,
        },
        {
          subtitle: "What we’re excited about in 2021",
          content: `
              As we look toward 2021, we’re looking forward to the Vue.js ecosystem continuing to evolve along with its freshly empowered core library.
  
              Since Vue 3 was released in September of 2020, this of course means that not every Vue developer and company using Vue have <a target="_blank" href="https://www.vuemastery.com/courses/from-vue2-to-vue3/from-vue-2-to-vue-3">transitioned to the new-and-improved version</a>. As we progress into 2021, more of the Vue community will have had time to explore the framework and share their experiences, expertise, and production use cases that we can all learn from.
              `,
        },
        {
          subtitle: "More compatibility",
          content: `
              We can also look forward to existing tools and libraries in the ecosystem becoming compatible with Vue 3. While libraries such as Vue Test Utils and Ionic Vue are already Vue 3-ready, we can look forward to additional community favorites such as Vuetify, Nuxt.js, Vuelidate, etc seamlessly plugging into our Vue 3 apps in 2021.
                `,
        },
        {
          subtitle: "Developer Experience",
          content: `
              In addition to updated popular libraries, we can also look forward to new additions to the Vue ecosystem, like <a target="_blank" href="https://github.com/znck/vue-developer-experience">VueDX</a>: a set of tools for a better developer experience with Vue.
              `,
        },
        {
          subtitle: "Leveling up in 2021",
          content: `
            The Vue ecosystem is rich with exciting changes and consistent updates. To stay current with your Vue skills and to stay competitive for 2021 and beyond, we recommend using a Vue learning resource such as Vue Mastery to level-up your skills. Our library of video courses is updated every week, helping you stay relevant in your role.
  
            You can currently get a 20% off discount for a year subscription to our platform. This means you’ll be getting 4 months free compared to our regular annual price. You can get your discount here before it runs out. We also have team accounts to level-up your team together!
              `,
        },
      ],
    },
  ],
};
